import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { PulseLoader } from 'react-spinners';
import { Button } from 'reactstrap';
  
export interface CaptchaProps {
    onSumbit: (t: string) => void,
    disabled: boolean
}

export const CaptchaButton = (props: CaptchaProps) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
  
    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = async () => {
      if (!executeRecaptcha) {
        console.warn("unavailable")
        return;
      }
  
      const token = await executeRecaptcha('submitForm');
      props.onSumbit(token)
    };
  
    return <Button disabled={props.disabled} onClick={handleReCaptchaVerify}>{
      props.disabled ? <PulseLoader color='#FFF' /> : "Regalar"}</Button>;
  };